import React from 'react';

import withAppState from '../mobx/withAppState'

import GratuityInput from './GratuityInput';

import accounting from 'accounting';
import plusIcon from '../assets/img/plus.svg';
import minusIcon from '../assets/img/minus.svg';

const elementPlus = <img src={plusIcon} alt="plus" />;
const elementMinus = <img src={minusIcon} alt="minus" />;

const SLIDER_VALUES = [0, 10.0, 12.5, 15.0, 17.5, 20.0, 22.5];

const MAX_VALUE = 250;

class ApplyGratuity extends React.Component {
  constructor(props) {
    super(props);
    const sliderValueSelected = 2;
    const gratuityPercentage = SLIDER_VALUES[sliderValueSelected];

    const originalTotal = this.props.billTotal + this.props.discountTotal;
    const gratuityTotal = (
      (originalTotal / 100) *
      gratuityPercentage
    ).toFixed(2);

    this.props.setGratuityTotal(gratuityTotal);

    this.state = {
      sliderValueSelected,
      cachedCustomValue: gratuityTotal,
      enteringCustomAmount: false,
      theCurrency: null
    };
    this.cursor = null;
  }

  setMainCTAText() {
    const mainCTAText = `Pay ${this.props.getCurrency().symbol +(
      parseFloat(this.props.billTotal) +
      parseFloat(this.props.gratuityTotal || 0)
    ).toFixed(2)}`;
    this.props.setMainCTAText(mainCTAText);
  }

  componentDidMount() {
    this.setMainCTAText();
    this.props.setMainCTA(this.props.mainCTACallback.bind(this));
    (async () => {
      var updateLoadingAnimation = false;
    this.props.refreshTable(updateLoadingAnimation);
    })();
    this.setState({theCurrency: this.props.getCurrency()?.currency});
  }

  componentDidUpdate() {
    const gratuityPercentage = SLIDER_VALUES[this.state.sliderValueSelected];
    const originalTotal = this.props.billTotal + this.props.discountTotal;
    if (this.state.enteringCustomAmount === false) {
      const gratuityTotal = (
        (originalTotal / 100) *
        gratuityPercentage
      ).toFixed(2);
      this.props.setGratuityTotal(gratuityTotal);
    }
    this.setMainCTAText();
  }

  countDecimals(value) {
    try{
      if(Math.floor(this.valueOf(value)) === this.valueOf(value)) return 0;
      return value.toString().split(".")[1].length || 0; 
    }
    catch(ex){
      return 0;
    }
  }

  handleIncreasePress() {
    if (this.state.enteringCustomAmount === true) {
      this.handleCancelCustomGratuity(1);
    } else {
      let sliderValueSelected = this.state.sliderValueSelected;
      if (sliderValueSelected + 1 < SLIDER_VALUES.length) {
        sliderValueSelected += 1;

        const gratuityPercentage = SLIDER_VALUES[sliderValueSelected];
        const originalTotal = (this.props.billTotal + this.props.discountTotal)
        const gratuityTotal = (
          (originalTotal / 100) *
          gratuityPercentage
        ).toFixed(2);
        this.setState({
          sliderValueSelected,
          cachedCustomValue: gratuityTotal
        });
        this.props.setGratuityTotal(gratuityTotal);
      }
    }
  }

  handleDecreasePress() {
    if (this.state.enteringCustomAmount === true) {
      this.handleCancelCustomGratuity(-1);
    } else {
      let sliderValueSelected = this.state.sliderValueSelected;
      if (sliderValueSelected - 1 >= 0) {
        sliderValueSelected -= 1;

        const gratuityPercentage = SLIDER_VALUES[sliderValueSelected];
        const originalTotal = this.props.billTotal + this.props.discountTotal;
        const gratuityTotal = (
          (originalTotal / 100) *
          gratuityPercentage
        ).toFixed(2);
        this.setState({
          sliderValueSelected,
          cachedCustomValue: gratuityTotal
        });
        this.props.setGratuityTotal(gratuityTotal);
      }
    }
  }

  handleCancelCustomGratuity(amount) {
    const originalTotal = this.props.billTotal + this.props.discountTotal;
    let customGratuityPercentage =
      (this.state.cachedCustomValue / originalTotal) * 100;
    customGratuityPercentage = customGratuityPercentage.toFixed(2);
    const totalSliderValues = SLIDER_VALUES.length;

    let sliderWasChanged = false;
    let sliderValueSelected = null;
    if (amount === 1) {
      for (var i = 0; i < totalSliderValues; i++) {
        if (SLIDER_VALUES[i] > customGratuityPercentage) {
          sliderValueSelected = i;
          this.setState({ sliderValueSelected });
          sliderWasChanged = true;
          break;
        }
      }
      if (sliderWasChanged === false) {
        sliderValueSelected = totalSliderValues - 1;
        this.setState({ sliderValueSelected });
      }
    } else if (amount === -1) {
      for (var j = totalSliderValues - 1; j >= 0; j--) {
        if (SLIDER_VALUES[j] < customGratuityPercentage) {
          sliderValueSelected = j;
          this.setState({ sliderValueSelected });
          sliderWasChanged = true;
          break;
        }
      }
      if (sliderWasChanged === false) {
        sliderValueSelected = 0;
        this.setState({ sliderValueSelected });
      }
    }

    const gratuityPercentage = SLIDER_VALUES[sliderValueSelected];
    const gratuityTotal = (
      (originalTotal / 100) *
      gratuityPercentage
    ).toFixed(2);

    this.props.setGratuityTotal(gratuityTotal);
    this.setState({
      enteringCustomAmount: false,
      cachedCustomValue: gratuityTotal
    });
  }

  handleChange(event) {
    const maskedValue = event.target.value;
    let value = accounting.unformat(maskedValue);
    console.log("value", value)
    if(/*value.toString()[0] === "0"*/ (this.countDecimals(value) > 2 || event.nativeEvent.data === "0")){
      value = accounting.toFixed(value * 10, 2);
      if(value > MAX_VALUE){
        value = MAX_VALUE;
      }
      this.setState({
        cachedCustomValue: value,
        enteringCustomAmount: true
      });
      this.props.setGratuityTotal(value);
    }
  }

  handleKeyDown(event) {
    const key = event.key;
    const cachedCustomValue = this.state.cachedCustomValue;
    if (key === 'Backspace') {
      const value = (((cachedCustomValue * 100) / 10) | 0) / 100;
      const gratuityTotal = accounting.toFixed(value, 2);
      this.props.setGratuityTotal(gratuityTotal);
      this.setState({
        enteringCustomAmount: true,
        cachedCustomValue: gratuityTotal
      });
      event.preventDefault();
    } else if (key === 'Enter') {
      event.target.blur();
    }
  }

  render() {
    const originalTotal = this.props.billTotal + this.props.discountTotal;
    const gratuityPercentage = this.state.enteringCustomAmount
      ? (this.state.cachedCustomValue / originalTotal) * 100
      : SLIDER_VALUES[this.state.sliderValueSelected];
    const gratuityTotal = this.state.enteringCustomAmount
      ? this.state.cachedCustomValue
      : this.props.gratuityTotal;
    let maskedGratuityTotal;
    if (!!this.state.theCurrency)  {
      maskedGratuityTotal = Number(gratuityTotal).toLocaleString(this.props.getCurrency()?.language, {
        style: 'currency',
        currency: this.state.theCurrency
      });
    } else {
      maskedGratuityTotal = Number(gratuityTotal)
    }
    return (
      <div className="gratuity-container" tabIndex="0">      
        <div className="percentage-scroll-wrapper">
          <div className="btn-column">
            <div
              className="gratuity-minus btn btn-secondary"
              onMouseDown={() => this.handleDecreasePress()}
            >
              {elementMinus}
            </div>
          </div>

          <div
            className={'percentage-scroll ' + this.state.enteringCustomAmount}
          >
            <h2 className="gratuity-percentage">
              {gratuityPercentage.toFixed(1)}%
            </h2>
          </div>

          <div className="btn-column">
            <div
              className="gratuity-plus btn btn-secondary"
              onMouseDown={() => this.handleIncreasePress()}
            >
              {elementPlus}
            </div>
          </div>

          <div className="gratuity-input-wrap">
            <GratuityInput
              className={'gratuity-input ' + this.state.enteringCustomAmount}
              value={maskedGratuityTotal}
              id="gratuity"
              onChange={e => {
                this.handleChange(e);
              }}
              onKeyDown={e => {
                this.handleKeyDown(e);
              }}
            />
          </div>
        </div>

        <ul className="bill-item-block bill-category-subtotal">
          <li className="bill-item-text">
            <p>Your Meal:</p>
          </li>
          <li className="bill-item-amount">
            <p>{this.props.getCurrency().symbol}{(originalTotal).toFixed(2)}</p>
          </li>
        </ul>
        <ul className="bill-item-block bill-category-subtotal">
          <li className="bill-item-text">
            <p>After Discounts:</p>
          </li>
          <li className="bill-item-amount">
            <p>{this.props.getCurrency().symbol + this.props.billTotal.toFixed(2)}</p>
          </li>
        </ul>
        <ul className="bill-item-block bill-category-subtotal">
          <li className="bill-item-text">
            <p>Gratuity:</p>
          </li>
          <li className="bill-item-amount">
            <p>{this.props.getCurrency().symbol+ gratuityTotal}</p>
          </li>
        </ul>
        <div className="small-print">
          <p>
            All cash tips go to your waiter. But card tips and service charge
            are different. Tips made on electronic card payments are fully
            distributed among our employees with no deductions. Currently, 50
            percent of card-based tips go to cleaners, chefs and other kitchen
            staff; with the remaining 50 percent going to your waiter as a
            reward for great customer service.
          </p>
        </div>
      </div>
    );
  }
}

export default withAppState(ApplyGratuity,
  {
    mobXProps: ({
      discountTotal,
      gratuityTotal,
      billTotal,
    }) => ({
      discountTotal,
      gratuityTotal,
      billTotal,
    }),
    mobXActions: ({ 
      setGratuityTotal,
      setMainCTAText,
      setMainCTA,
      refreshTable,
      setGrandTotal,
      getCurrency
    }) => ({
      setGratuityTotal,
      setMainCTAText,
      setMainCTA,
      refreshTable,
      setGrandTotal,
      getCurrency
    })
  }
);